import script from "./GroupMsgItemChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupMsgItemChat.vue?vue&type=script&setup=true&lang=ts"

import "./GroupMsgItemChat.vue?vue&type=style&index=0&id=2e99d86a&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e99d86a"]])

export default __exports__